export default {
  tape: {},
};
